import { useState } from 'react';
import { getRunsAPI } from '../services/runsAPI';
import { useLoading } from '../contexts/LoadingContext';
import { useError } from '../contexts/ErrorContext';

/**
 * Gets all runs and creates dropdown options.
 * 
 * @returns {DropdownOption[]} runNameOptions
 * @returns {Function} fetchRuns - gets runs, creates options, adds them to state
 * @returns {Function} clearRuns - clear all run options from state
 * 
 * @category Hooks - Dropdown Options
 */
const useRunOptions = () => {
    const [runNameOptions, setRunNameOptions] = useState([]);
    
    const { showLoading, hideLoading } = useLoading();
    const { showError } = useError();

    const clearRuns = () => {
        setRunNameOptions([]);
    }

    const fetchRuns = async (jobID) => {
        showLoading('Getting Runs...');
        try {
            const response = await getRunsAPI(jobID);

            if (!response.success) {
                throw new Error(`HTTP error: ${response.message}`);
            }
            const runs = response.data;
            

            if (runs.length > 0) {
                const runOptions = runs.map(run => ({
                    value: run.RunID,
                    label: `${run.Run_Name}`
                }));
                
                setRunNameOptions(runOptions);
            }                
        } catch (error) {
            showError(`Error Getting Runs - ${error.message}`);
        } finally {
            hideLoading();
        }
    };

    return { runNameOptions, fetchRuns, clearRuns };
};

export default useRunOptions;
